import dynamic from 'next/dynamic';
import { PropsWithChildren } from 'react';

import { FormattedMessage } from 'react-intl';

import Icon from 'components/@tedui/Icon';
import { BaseButtonType } from 'components/base-button';
import { TalkActionButtonProps } from './TalkActionButton.props';

const Button = dynamic(() => import('components/button'), {
  ssr: false
});

const TalkActionButton = ({
  ref,
  onClick,
  iconName,
  label,
  disabled = false,
  testId,
  children
}: PropsWithChildren<TalkActionButtonProps> & {
  ref: React.RefObject<HTMLButtonElement | null>;
}) => {
  return (
    <Button
      data-testid={testId}
      ref={ref}
      disabled={disabled}
      onClick={onClick}
      variant={BaseButtonType.GhostLink}
      small
      className="bg-gray-300 text-sm font-medium hover:z-0 md:bg-transparent md:hover:bg-gray-300"
    >
      <Icon
        className="mr-3 h-4 w-4 flex-shrink-0 origin-left scale-125 transform"
        iconName={iconName}
      />
      <FormattedMessage
        defaultMessage="{label}"
        values={{
          label
        }}
      />
      {children}
    </Button>
  );
};

export default TalkActionButton;
